export const DEFAULT_SNOOZE_TIMER = 15 * 60;

// Choices come from backend company or team settings
export const SNOOZE_TIMER_CHOICES = [15 * 60, 45 * 60, 90 * 60];
